import { Color } from "./colors.js";
const passScoreCategories = [
  {
    score: true,
    color: Color.Green,
    label: "Yes"
  },
  {
    score: false,
    color: Color.Red,
    label: "No"
  }
];
const fallbackPassScoreCategory = {
  score: false,
  color: Color.Gray,
  label: "Unknown"
};
function getPassScoreCategory(score) {
  return passScoreCategories.find((c) => score === c.score) ?? fallbackPassScoreCategory;
}
function getPassScoreColor(score) {
  return getPassScoreCategory(score).color;
}
function getPassScoreLabel(score) {
  return getPassScoreCategory(score).label;
}
export {
  getPassScoreCategory,
  getPassScoreColor,
  getPassScoreLabel
};
//# sourceMappingURL=passScore.js.map
